<template>
  <div class="requirements-list-area bg-gray py-4" id="merchants">
    <div class="row align-items-center">
      <div class="col-lg-6 order-2">
        <div class="requirements-list left">
          <div class="mt-20 mb-20">
            <h5 class="requirements-list__title mb-15 wow move-up">
              Value-Proposition durch Raritäten stärken
            </h5>
            <p class="heading mb-30 wow move-up">
              Mit dem Zugang zu unserem MHP-Portal besteht die Möglichkeit für Sie als Gewerbetreibender oder Freiberufler
              durch die über 100.000 Mitwirkenden im Netzwerk Ihr Produktsortiment für Ihre Kunden um fehlende und rare
              Werke zu ergänzen. Hierdurch gehen Sie den individuellen Anfragen Ihrer Kunden gezielt nach und bieten ihnen
              exklusive Offerten an.
            </p>
          </div>
          <div class="mb-20 mt-40">
            <h5 class="requirements-list__title mb-15 wow move-up">
              Optimierung Ihrer Produktpalette
            </h5>
            <p class="heading mb-30 wow move-up">
              Unser weitverzweigtes Netzwerk bietet Ihnen ebenso die Möglichkeit Produkte Ihres Inventars über das
              MHP-Portal zu veräußern und martkgerechte Angebote für diese zu erhalten. Damit reduzieren Sie Ihre Bestände
              um Überschüsse und können folglich Ihre angebotene Produktpalette besserstellen.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 order-1">
        <div class="requirements-list-image wow move-up mx-auto">
          <img src="../assets/img/features/product_iteration.svg" class="img-fluid" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'requireList'
}
</script>